import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { TyreAgreement } from '../_models/tyreAgreement';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';
import { Dealer } from 'app/_models/dealer';
import { Customer } from 'app/_models/customer';
import { Tyre } from '../_models/tyre';

@Injectable()
export class TyreAgreementsService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }

  getAll(): Observable<TyreAgreement[]>{
    let agreements$ = this.http
      .get(`${this.baseUrl}/tyreagreements?populate=customer&populate=tyre`, this.makeHeaders())
      .map(mapAgreements)
      .catch(handleError);
    return agreements$;
  }

  get(id: string): Observable<TyreAgreement> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/tyreagreements/${id}?populate=customer&populate=tyre`, this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return agreement$;
  }

  getForCustomer(customerId: string): Observable<TyreAgreement[]> {
    let agreements$ = this.http
      .get(`${this.baseUrl}/customer-agreements/${customerId}`, this.makeHeaders())
      .map(mapAgreements)
      .catch(handleError);
    return agreements$;
  }

  create(agreement: TyreAgreement): Observable<TyreAgreement>{
    let newAgreement = this.http
      .post(`${this.baseUrl}/tyreagreements`, JSON.stringify(agreement), this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return newAgreement;
  }

  read(id: string): Observable<TyreAgreement> {
    let agreement = this.http
      .get(`${this.baseUrl}/tyreagreements/${id}?populate=customer&populate=tyre`, this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return agreement;
  }

  update(agreement: TyreAgreement): Observable<TyreAgreement>{
    let updatedAgreement = this.http
      .put(`${this.baseUrl}/tyreagreements/${agreement._id}`, JSON.stringify(agreement), this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);

    return updatedAgreement;
  }

  delete(id: string) : Observable<Response>{
    return this.http
      .delete(`${this.baseUrl}/tyreagreements/${id}`, this.makeHeaders())
        .map((res:Response) => res.json()) // ...and calling .json() on the response to return data
        .catch((error:any) => Observable.throw(error.json().error || 'Server error')); //...errors if any
  }

  getDealer(id: string): Observable<TyreAgreement[]>{
    let agreements$ = this.http
      .get(`${this.baseUrl}/tyreagreements?status=true&dealer_id=${id}&populate=customer&populate=tyre&type=tyre`, this.makeHeaders())
      .map(mapAgreements)
      .catch(handleError);
    return agreements$;
  }

  acceptAgreement(agreement: TyreAgreement, dealer: Dealer, mauticId: string): Observable<Response> {
    var options = this.makeHeaders();
    return this.http
      .get(`${this.baseUrl}/tyreagreements/${agreement._id}/accept-agreement?dealer=${dealer._id}&mauticId=${mauticId}`, options)
        .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  savePdf(agreement : any) {
    let newAgreement = this.http
      .post(`${this.baseUrl}/agreementPdf`, JSON.stringify(agreement), this.makeHeaders());
    return newAgreement;
  }

  private makeHeaders():RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    //headers.append("Access-Control-Allow-Origin", "*");
    //headers.append("Access-Control-Allow-Methods", "DELETE, POST, GET, OPTIONS");
    //headers.append("Access-Control-Allow-Headers", "Content-Type, Authorization, X-Requested-With");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapAgreements(response:Response): TyreAgreement[]{
   // uncomment to simulate error:
   // throw new Error('ups! Force choke!');
   return response.json().map(toAgreement);
}

function toAgreement(r:any): TyreAgreement{
  let agreement = <TyreAgreement>({
    _id: r._id,
    customer: r.customer,
    addons: r.addons,
    tyre: r.tyre,
    tyre_price: r.tyre_price,
    mounting_price: r.mounting_price,
    final_amount: r.final_amount,
    contract_date: r.contract_date,
    status: r.status,
    pdf: r.pdf,
    dealer_id: r.dealer_id,
    sellerInitials: r.sellerInitials,
    customerAccept: r.customerAccept,
    change_tyre_1: r.change_tyre_1,
    change_tyre_2: r.change_tyre_2,
    change_tyre_3: r.change_tyre_3,
    change_tyre_4: r.change_tyre_4,
    order_type: r.order_type,
    order_completed: r.order_completed,
    viewPDF: r.viewPDF
  });
  return agreement;
}

function mapAgreement(response:Response): TyreAgreement{
  // toPerson looks just like in the previous example
  return toAgreement(response.json());
}

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/tyreAgreements.service.ts